import { render, staticRenderFns } from "./domainItem.vue?vue&type=template&id=26d4e86c&scoped=true&"
import script from "./domainItem.vue?vue&type=script&lang=js&"
export * from "./domainItem.vue?vue&type=script&lang=js&"
import style0 from "./domainItem.vue?vue&type=style&index=0&id=26d4e86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d4e86c",
  null
  
)

export default component.exports